// import DataTable from '@/components/functional/DataTable/DataTable';
// import { Goer, useGetAllGoers } from '@/hooks/useGetGoers';
// import { createColumnHelper } from '@tanstack/react-table';
import { FC } from 'react';

// const columnHelper = createColumnHelper<Goer>();

// const columns = [
//   columnHelper.accessor('id', {
//     header: () => <span>User's ID</span>,
//     cell: (info) => info.getValue(),
//     footer: (info) => info.column.id,
//   }),
//   columnHelper.accessor('email', {
//     header: () => <span>User's Email</span>,
//     cell: (info) => info.getValue(),
//     footer: (info) => info.column.id,
//   }),
//   columnHelper.accessor((row) => row.created_at, {
//     id: 'created_at',
//     cell: (info) => {
//       const date = new Date(info.getValue());
//       return date.toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric',
//       });
//     },
//     header: () => <span>Join Date</span>,
//     footer: (info) => info.column.id,
//   }),
// ];

const AdminBuildings: FC = () => {
  // const { data: goers } = useGetAllGoers();
  return (
    <div className="flex flex-col gap-4">
      <div className="flex py-4 px-6 rounded-full bg-white border">
        <h1 className=" text-1xl font-bold">AdminBuildings</h1>
      </div>
      <div className="flex gap-2">{/* <DataTable data={goers || []} columns={columns} /> */}</div>
    </div>
  );
};

export default AdminBuildings;
